// Generated by Melange

import * as JsxRuntime from "react/jsx-runtime";

function s(prim) {
  return prim;
}

function Comps(Props) {
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("article", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "King Post",
                    className: "title"
                  }),
                  JsxRuntime.jsxs("p", {
                    children: [
                      "Comps scored with ",
                      JsxRuntime.jsx("a", {
                        children: "Flare Timing",
                        href: "https://flaretiming.com"
                      }),
                      " and presented with ",
                      JsxRuntime.jsx("a", {
                        children: "ReasonReact",
                        href: "https://reasonml.github.io/reason-react/"
                      })
                    ],
                    className: "subtitle"
                  })
                ],
                className: "tile is-child notification is-light"
              }),
              className: "tile is-parent"
            }),
            className: "tile is-ancestor"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              "Want",
              JsxRuntime.jsx("a", {
                children: " your comp here",
                href: "https://flaretiming.com/posts/2018-12-19-add-a-comp.html"
              }),
              "?"
            ]
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h3", {
                            children: "Paragliding"
                          }),
                          JsxRuntime.jsx("p", {}),
                          JsxRuntime.jsxs("ul", {
                            children: [
                              JsxRuntime.jsxs("li", {
                                children: [
                                  "Italian Open ",
                                  JsxRuntime.jsx("a", {
                                    children: "2020",
                                    href: "/comp-prefix/2020-italy-open"
                                  })
                                ]
                              }),
                              JsxRuntime.jsxs("li", {
                                children: [
                                  "Dalmatian ",
                                  JsxRuntime.jsx("a", {
                                    children: "2019",
                                    href: "/comp-prefix/2019-dalmatian"
                                  }),
                                  " ",
                                  JsxRuntime.jsx("a", {
                                    children: "2018",
                                    href: "/comp-prefix/2018-dalmatian"
                                  })
                                ]
                              }),
                              JsxRuntime.jsx("ul", {
                                children: JsxRuntime.jsx("p", {})
                              })
                            ]
                          })
                        ],
                        className: "tile is-child box"
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h3", {
                            children: "Comp Archetypes"
                          }),
                          JsxRuntime.jsx("p", {}),
                          JsxRuntime.jsxs("ul", {
                            children: [
                              JsxRuntime.jsx("li", {
                                children: JsxRuntime.jsx("a", {
                                  children: "1976 Never Land",
                                  href: "/comp-prefix/1976-never-land"
                                })
                              }),
                              JsxRuntime.jsx("li", {
                                children: JsxRuntime.jsx("a", {
                                  children: "1989 Lift Lines",
                                  href: "/comp-prefix/1989-lift-lines"
                                })
                              }),
                              JsxRuntime.jsx("ul", {
                                children: JsxRuntime.jsx("p", {})
                              })
                            ]
                          })
                        ],
                        className: "tile is-child box"
                      })
                    ],
                    className: "tile is-parent is-vertical"
                  }),
                  className: "tile"
                }),
                className: "tile is-vertical is-5"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h3", {
                          children: "Hang Gliding"
                        }),
                        JsxRuntime.jsx("h5", {
                          children: "Oceania"
                        }),
                        JsxRuntime.jsxs("ul", {
                          children: [
                            JsxRuntime.jsxs("li", {
                              children: [
                                "Forbes Flatlands ",
                                JsxRuntime.jsx("a", {
                                  children: "2018",
                                  href: "/comp-prefix/2018-forbes"
                                }),
                                " ",
                                JsxRuntime.jsx("a", {
                                  children: "2017",
                                  href: "/comp-prefix/2017-forbes"
                                }),
                                " ",
                                JsxRuntime.jsx("a", {
                                  children: "2016",
                                  href: "/comp-prefix/2016-forbes"
                                }),
                                " ",
                                JsxRuntime.jsx("a", {
                                  children: "2015",
                                  href: "/comp-prefix/2015-forbes"
                                }),
                                " ",
                                JsxRuntime.jsx("a", {
                                  children: "2014",
                                  href: "/comp-prefix/2014-forbes"
                                }),
                                " ",
                                JsxRuntime.jsx("a", {
                                  children: "2012",
                                  href: "/comp-prefix/2012-forbes"
                                })
                              ]
                            }),
                            JsxRuntime.jsxs("li", {
                              children: [
                                "Dalby Big Air ",
                                JsxRuntime.jsx("a", {
                                  children: "2017",
                                  href: "/comp-prefix/2017-dalby"
                                })
                              ]
                            })
                          ]
                        }),
                        JsxRuntime.jsx("h5", {
                          children: "Europe"
                        }),
                        JsxRuntime.jsxs("ul", {
                          children: [
                            JsxRuntime.jsxs("li", {
                              children: [
                                "Meduno ",
                                JsxRuntime.jsx("a", {
                                  children: "2020",
                                  href: "/comp-prefix/2020-meduno"
                                })
                              ]
                            }),
                            JsxRuntime.jsxs("li", {
                              children: [
                                "Tolmezzo ",
                                JsxRuntime.jsx("a", {
                                  children: "2019",
                                  href: "/comp-prefix/2019-italy"
                                })
                              ]
                            })
                          ]
                        }),
                        JsxRuntime.jsx("h5", {
                          children: "Americas"
                        }),
                        JsxRuntime.jsxs("ul", {
                          children: [
                            JsxRuntime.jsxs("li", {
                              children: [
                                "Green Swamp Klassic 2016 ",
                                JsxRuntime.jsx("a", {
                                  children: "Topless",
                                  href: "/comp-prefix/2016-greenswamp"
                                }),
                                " ",
                                JsxRuntime.jsx("a", {
                                  children: "Kingposted",
                                  href: "/comp-prefix/2016-greenswamp-sport"
                                })
                              ]
                            }),
                            JsxRuntime.jsxs("li", {
                              children: [
                                "Big Spring ",
                                JsxRuntime.jsx("a", {
                                  children: "2016",
                                  href: "2016-big-spring"
                                })
                              ]
                            }),
                            JsxRuntime.jsxs("li", {
                              children: [
                                "QuestAir Open ",
                                JsxRuntime.jsx("a", {
                                  children: "2016",
                                  href: "/comp-prefix/2016-quest"
                                })
                              ]
                            })
                          ]
                        })
                      ],
                      className: "tile is-child box"
                    }),
                    className: "tile is-parent is-vertical"
                  }),
                  className: "tile"
                }),
                className: "tile is-vertical is-7"
              })
            ],
            className: "tile is-ancestor"
          })
        ],
        className: "content",
        id: "content"
      })]
  });
}

const make = Comps;

export {
  s,
  make,
}
/* react/jsx-runtime Not a pure module */
